/**
 * @generated SignedSource<<af40ff23f6ebccfc3c6bae080ad78c03>>
 * @relayHash f57cbaebcb2c745812373389af708333
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6d769546aa48fc4fad8c8354f0c98216c074bfa08d79265e33e91651fe1a0b72

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AutomaticTeamAssignmentRowPreloadedQuery } from './AutomaticTeamAssignmentRowPreloadedQuery.graphql';

const node: PreloadableConcreteRequest<AutomaticTeamAssignmentRowPreloadedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6d769546aa48fc4fad8c8354f0c98216c074bfa08d79265e33e91651fe1a0b72",
    "metadata": {},
    "name": "AutomaticTeamAssignmentRowPreloadedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
